import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import modelAPI from 'app/apiModel';
import { setSnackbar } from './snackbarSlice';

// AR video clips are a v0.4 resource, so they go through the versionless
// modelAPI client (the main API client bakes in /v0.3).
const constructUrl = (projectId, arVideoId = '') =>
    `/v0.4/projects/${projectId}/arvideos${arVideoId ? `/${arVideoId}` : ''}`;

export const getAllARVideos = createAsyncThunk('arVideo/getAll', async ({ projectId }, { dispatch }) => {
    try {
        const { data } = await modelAPI.get(constructUrl(projectId));
        return data;
    } catch (e) {
        dispatch(setSnackbar({ status: 'error', message: 'Failed to fetch AR Videos' }));
        throw e;
    }
});

export const deleteARVideo = createAsyncThunk('arVideo/delete', async ({ projectId, id }, { dispatch }) => {
    await modelAPI.delete(constructUrl(projectId, id));
    dispatch(setSnackbar({ status: 'success', message: 'AR Video deleted successfully' }));
    return id;
});

const arVideoSlice = createSlice({
    name: 'arVideo',
    initialState: {
        arVideos: {},
        loading: false,
        error: null,
    },
    reducers: {
        clearARVideos: () => arVideoSlice.getInitialState(),
    },
    extraReducers: (builder) => {
        builder
            .addCase(getAllARVideos.pending, (state) => { state.loading = true; state.error = null; })
            .addCase(getAllARVideos.fulfilled, (state, action) => {
                state.loading = false;
                state.arVideos = action.payload.reduce((acc, clip) => {
                    acc[clip.id] = clip;
                    return acc;
                }, {});
            })
            .addCase(getAllARVideos.rejected, (state, action) => { state.loading = false; state.error = action.error.message; })
            .addCase(deleteARVideo.fulfilled, (state, action) => {
                delete state.arVideos[action.payload];
            });
    },
});

export const { clearARVideos } = arVideoSlice.actions;
export default arVideoSlice.reducer;
